import { EnvironmentType } from "@app-context/environments/context";
import { ValueOf } from "@enfusion-ui/types";

export const APISources = {
  CORE: "systematic",
  INTERNAL: "internal",
} as const;

export type APISource = ValueOf<typeof APISources>;

type FetchCall = <T = string>(
  env: EnvironmentType,
  endpoint: string,
  params?: Record<string, unknown>
) => Promise<[T, Response]>;

export type SocketType = "oems" | "reports";

type SocketListener = (
  env: EnvironmentType,
  type: SocketType,
  source: APISource,
  onMessage: (message: string) => void
) => {
  unsubscribe: VoidFunction;
  postMessage: (message: string) => void;
};

export type NetworkCallsContextState = {
  fetchCall: FetchCall;
  subscribeSocket: SocketListener;
};
